import styled from '@emotion/styled';

export const StyledDestination = styled.div`
  font: var(--font-body-m-light);
  margin-top: var(--spacing-24);
`;

export const StyledDestinationNights = styled.span`
  font: var(--font-body-m-light);
  margin-left: var(--spacing-4);
  color: var(--color-secondary-60);
`;

export const StyledDestinationName = styled.p`
  color: var(--color-black);
  font: var(--font-body-m-bold);
`;

export const InspirationalMessage = styled.p`
  color: var(--color-secondary-60);
  font: var(--font-body-l-bold);
`;

export const Ul = styled.ul`
  list-style: disc;
  margin-top: var(--spacing-8);
  padding-inline-start: var(--spacing-24);
`;

export const Li = styled.li`
  padding-left: var(--spacing-4);
  color: var(--color-secondary-60);
`;
